import { render, staticRenderFns } from "./CardReward.vue?vue&type=template&id=7815070d&scoped=true&lang=pug"
import script from "./CardReward.vue?vue&type=script&lang=js"
export * from "./CardReward.vue?vue&type=script&lang=js"
import style0 from "./CardReward.vue?vue&type=style&index=0&id=7815070d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815070d",
  null
  
)

export default component.exports